import { SxProps, Theme } from '@mui/material'
import CustomPalette from '@/theme/CustomPalette'

export const toolbarStyles: SxProps<Theme> = {
  minHeight: 64,
  px: 1.5,
  borderBottom: `1px solid ${CustomPalette.SecondaryNightBlue200}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  boxSizing: 'border-box',
}

export const logoContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  width: 50,
  minWidth: 50,
  flexShrink: 0,
}

export const logoImageStyles: SxProps<Theme> = {
  width: '100%',
  '& img': { maxWidth: '100%', height: 'auto' },
}

export const rightButtonsContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: { xs: 4, sm: 8 },
  flexShrink: 1,
  minWidth: 0,
  overflow: 'hidden',
}

export const languageIconButtonStyles: SxProps<Theme> = {
  color: CustomPalette.NightBlue200,
  padding: '10px',
  minWidth: '44px',
  minHeight: '44px',
  flexShrink: 0,
}

export const pageIconButtonStyles: SxProps<Theme> = {
  backgroundColor: CustomPalette.SecondaryNightBlue200,
  borderRadius: '12px',
  padding: '10px 14px',
  minWidth: '44px',
  minHeight: '44px',
  '&:hover': {
    backgroundColor: CustomPalette.Air,
  },
}

export const pageTitleButtonStyles: SxProps<Theme> = {
  backgroundColor: CustomPalette.SecondaryNightBlue100,
  borderRadius: '20px',
  padding: '10px 16px',
  minHeight: '44px',
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexShrink: 1,
  minWidth: 0,
  maxWidth: '100%',
  '&:hover': {
    backgroundColor: CustomPalette.Air,
  },
}

export const pageTitleTextStyles: SxProps<Theme> = {
  fontSize: '16px',
  color: CustomPalette.NightBlue200,
  textTransform: 'none',
  lineHeight: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  flexShrink: 1,
  minWidth: 0,
}

export const menuPaperStyles: SxProps<Theme> = {
  position: 'fixed !important',
  top: '64px !important',
  right: '0 !important',
  left: 'auto !important',
  width: '100vw',
  margin: 0,
  backgroundColor: CustomPalette.SecondaryCloud,
  boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)',
  borderRadius: 0,
  borderBottomLeftRadius: '10px',
  borderBottomRightRadius: '10px',
  borderLeft: `1px solid ${CustomPalette.SecondaryNightBlue200}`,
  borderBottom: `1px solid ${CustomPalette.SecondaryNightBlue200}`,
}

export const languageMenuPaperStyles: SxProps<Theme> = {
  ...menuPaperStyles,
  maxWidth: 240,
}

export const navigationMenuPaperStyles: SxProps<Theme> = {
  ...menuPaperStyles,
  maxWidth: 320,
}

export const listItemButtonStyles: SxProps<Theme> = {
  py: 2,
  px: 3,
  '&.Mui-selected': {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: CustomPalette.SecondaryCloud,
    },
  },
  '&:hover': {
    backgroundColor: CustomPalette.SecondaryCloud,
  },
}

export const navigationListItemButtonStyles: SxProps<Theme> = {
  py: 2,
  pl: 5,
  pr: 3,
  '&.Mui-selected': {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: CustomPalette.SecondaryCloud,
    },
  },
  '&:hover': {
    backgroundColor: CustomPalette.SecondaryCloud,
  },
}

export const listItemTextStyles = (isSelected: boolean): SxProps<Theme> => ({
  '& .MuiListItemText-primary': {
    fontSize: '16px',
    fontWeight: isSelected ? 500 : 400,
    lineHeight: 1,
    letterSpacing: 0,
    color: CustomPalette.SecondaryNightBlue900,
  },
})

export const sectionHeaderTextStyles: SxProps<Theme> = {
  '& .MuiListItemText-primary': {
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '0.02em',
    color: CustomPalette.SecondaryNightBlue900,
  },
}

export const checkmarkStyles: SxProps<Theme> = {
  ml: 2,
  fontSize: '20px',
  color: CustomPalette.PilotBlue,
  fontWeight: 'bold',
}

export const logoutButtonStyles: SxProps<Theme> = {
  py: 2,
  px: 3,
  color: CustomPalette.PilotBlue,
  '&:hover': {
    backgroundColor: CustomPalette.SecondaryCloud,
  },
}

export const logoutTextStyles: SxProps<Theme> = {
  '& .MuiListItemText-primary': {
    fontSize: '16px',
    color: CustomPalette.PilotBlue,
  },
}

export const navbarRootStyles: SxProps<Theme> = {
  width: '100%',
  left: 0,
  right: 0,
  zIndex: (theme) => theme.zIndex.drawer + 1,
  boxSizing: 'border-box',
}

export const spacerStyles: SxProps<Theme> = {
  flexGrow: 1,
}

export const languageIconStyles: SxProps<Theme> = {
  fontSize: 24,
}

export const expandIconStyles: SxProps<Theme> = {
  fontSize: 20,
  color: CustomPalette.NightBlue200,
}

export const listStyles: SxProps<Theme> = {
  py: 1,
}

export const sectionListItemStyles: SxProps<Theme> = {
  px: 3,
  py: 2,
}

export const languageSectionListItemStyles = (hasRoutes: boolean): SxProps<Theme> => ({
  px: 3,
  py: 2,
  mt: hasRoutes ? 2 : 0,
  pt: hasRoutes ? 2 : 0,
  borderTop: hasRoutes ? `1px solid ${CustomPalette.SecondaryNightBlue200}` : 'none',
})

export const logoutListItemStyles: SxProps<Theme> = {
  mt: 2,
  pt: 1,
  borderTop: `1px solid ${CustomPalette.SecondaryNightBlue200}`,
}

export const logoutIconStyles: SxProps<Theme> = {
  mr: 2,
  fontSize: '18px',
}
